// (function () {
//     'use strict';
//
//     angular
//         .module('estadisticas')
//         .directive('grafico', GraficoDirective)
//     ;

    /**
     * Recibe un gráfico en forma de json y lo pinta
     */
    GraficoDirective.$inject = [];
    export default function GraficoDirective() {
        return {
            restrict: 'E',
            scope: {
                'json': '=',
                'vistaImpresion': '@',
                'mostrarTablas': '@',
                'hacerPeticion': '=',
                'vistaInforme': '@'
            },
            template: require('./grafico.html'),
            controller: 'GraficoDirectiveCtrl as vm',
            bindToController: true
        }
    }

// })();